<template>
  <div class="not-prose">
    <div v-if="office === ''" class="bg-white/5 p-4 md:p-8 xl:flex xl:items-center justify-between">
      <div class="xl:hidden" >
        <button
          @click="toggleFilters"
          class="form-button border-2 hover:bg-primary-dark flex items-center w-full sm:w-auto justify-between"
          :class="{
            'bg-primary-dark': showFilters,
            'bg-primary': !showFilters
          }"
        >
          Filter Agents & Staff
          <svg-vue
            v-if="!showFilters"
            icon="angle-down"
            class="fill-current h-4 w-4 ml-2"
          />
          <svg-vue
            v-if="showFilters"
            icon="angle-up"
            class="fill-current h-4 w-4 ml-2"
          />
        </button>
      </div>
      <p class="hidden xl:inline-block px-6 text-lg" >
        Filter Agents &amp; Staff:
      </p>
      <div
        class="xl:flex flex-wrap"
        :class="{
          'flex': showFilters,
          'hidden xl:flex space-x-6': !showFilters
        }"
      >
        <button
          @click="setActiveOffice('')"
          class="form-button text-base bg-transparent border-2 hover:bg-primary-dark w-full md:w-auto mt-2 lg:mt-0"
          :class="{
            'bg-accent': activeOffice == '',
            'bg-primary': activeOffice != '',
          }"
        >All</button>
        <button
          v-for="office in agents"
          :key="office.term_id"
          @click="setActiveOffice(office.name)"
          class="form-button text-base bg-transparent border-2 hover:bg-primary-dark w-full md:w-auto mt-2 lg:mt-0"
          :class="{
            'bg-accent': activeOffice == office.name,
            'bg-primary': activeOffice != office.name,
          }"
        >
          {{ office.name }}
        </button>
      </div>
    </div>

    <div v-for="office in agents" :key="office.ID" >
      <h2
        v-if="activeOffice === '' || office.name === ''"
        class="page-h2 after:ml-0 after:w-full text-accent-light after:h-0.5 mt-8 md:mt-20 mb-2 after:border-accent-light"
      >{{ office.name }}</h2>
      <div
        v-if="activeOffice === '' || activeOffice === office.name"
        class="grid md:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-4 gap-8 md:gap-16 lg:gap-20 pt-4 pb-8 md:pb-12"
      >
        <agent-card
          v-for="agent in office.items"
          :key="agent.ID"
          :agent="agent"
        ></agent-card>
      </div>
    </div>

  </div>
</template>

<script>
import AgentCard from './AgentCard.vue'

export default {
  name: "AgentsGrid",

  components: {
    AgentCard
  },

  props: {
    office: {
      type: String,
      default: ''
    },
    agents: {
      type: Object,
      default: () => {}
    }
  },

  data() {
    return {
      activeOffice: "",
      showFilters: false
    }
  },

  computed: {

  },

  mounted() {
    if(this.office !== '') {
      this.activeOffice = this.office
    }
  },

  methods: {
    setActiveOffice(value){
      this.activeOffice = value
      this.showFilters = false
    },

    toggleFilters(){
      this.showFilters = !this.showFilters
    }
  }

}
</script>
